import type { RaterXPreset } from '../../api/types/rater-x-preset';
import type { RatingOptions } from '../../types';
import type { CustomizeQuoteState } from '../../views/customize-quote/types';
import type { UnderwriteQuoteState } from '../../views/underwriter/types';

export const formatRatingOptions = (
  ratingOptions: RaterXPreset['rateModifierCategories'] | undefined
) => {
  const flattenedModifiers = flattenModifiers(ratingOptions);

  return (flattenedModifiers ?? [])?.reduce?.((acc, modifier) => {
    if (!modifier) {
      return acc;
    }

    return {
      ...acc,
      [modifier.key]: {
        ...modifier,
        readOnly: !modifier.rules,
      },
    };
  }, {} as RatingOptions);
};

const mergeUWRatingModifiersIntoState = <
  T extends Partial<
    UnderwriteQuoteState & CustomizeQuoteState & CustomizeQuoteState
  >
>(
  data: T
) => {
  const ratingOptions = formatRatingOptions(
    data.raterX?.rateModifierCategories
  );
  return {
    ...data,
    ratingOptions,
  };
};

export default mergeUWRatingModifiersIntoState;

export const flattenModifiers = (
  modifiers: RaterXPreset['rateModifierCategories'] | undefined
) => {
  if (!modifiers) {
    return [];
  }
  return modifiers.reduce((acc, modifier) => {
    return acc.concat(modifier.rateModifiers || []);
  }, [] as RaterXPreset['rateModifierCategories'][0]['rateModifiers']);
};
